import { secureApi } from 'services/api';
import {
  PricingInformation,
  GetPricingInformationRequest,
  CheckoutSession,
  CreateCheckoutSessionRequest,
  CreateCustomerPortalSessionRequest,
  CustomerPortalSession,
  CheckSubscriptionUpdate,
} from 'services/api/subscription/types';
import { RequestBuilder } from 'services/api/utils';
import { v4 as uuidv4 } from 'uuid';

export const subscriptionsApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    getPricingInformation: builder.query<
      PricingInformation[],
      GetPricingInformationRequest
    >({
      query: ({ keyName, businessUnit }) =>
        new RequestBuilder('/apiv2/subscription/prices')
          .setQueryParam('keyName', keyName)
          .setQueryParam('businessUnit', businessUnit)
          .buildArgs(),
    }),
    checkSubscriptionUpdate: builder.query<CheckSubscriptionUpdate, number>({
      query: (fetchedAt: number) => ({
        url: `/apiv2/subscription/check?lastChecked=${new Date(
          fetchedAt,
        ).toISOString()}`,
        method: 'GET',
      }),
    }),
    createCheckoutSession: builder.mutation<
      CheckoutSession,
      CreateCheckoutSessionRequest
    >({
      query: data =>
        new RequestBuilder('/apiv2/subscription')
          .setMethod('POST')
          .setHeader('Idempotency-Key', uuidv4())
          .setData(data)
          .buildArgs(),
    }),
    createCustomerPortalSession: builder.mutation<
      CustomerPortalSession,
      CreateCustomerPortalSessionRequest
    >({
      query: data =>
        new RequestBuilder('/apiv2/subscription/billing-session')
          .setMethod('POST')
          .setHeader('Idempotency-Key', uuidv4())
          .setData(data)
          .buildArgs(),
    }),
  }),
  overrideExisting: true,
});
